import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import H1 from "../../../components/typography/H1";
import { useInView } from "react-intersection-observer";
import OrdersSection from "./OrdersSection";
import ExclusivesSection from "./ExclusivesSection";
import WishlistSection from "./WishlistSection";

const Wrapper = styled.div``;

const Container = styled.div`
  display: flex;
  padding: 20px 40px;
  gap: 24px;
  flex-direction: column;

  @media (max-width: 950px) {
    padding: 20px;
  }
`;

const Header = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: center;
`;

const TabsWrapper = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 8px;
  flex-wrap: wrap;
  cursor: pointer;
  text-align: center;
  align-items: center;
  justify-content: center;
`;

const Tab = styled.span`
  position: relative;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  letter-spacing: 0.1rem;
  text-transform: capitalize;
  color: ${colors.black};
  font-size: ${fontSize.xxs};

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: ${colors.black};
    transform: translateX(-50%) scaleX(${(props) => (props.active ? 1 : 0)});
    transform-origin: center;
    transition: transform 0.3s ease;
  }

  &:hover::after {
    transform: translateX(-50%) scaleX(1);
  }
`;

const TABS = ["ORDERS", "WISHLIST", "EXCLUSIVES"];

function DashboardTabs() {
  const { ref, inView } = useInView({ triggerOnce: true });
  const [activeTab, setActiveTab] = useState(TABS[0]);

  return (
    <Wrapper ref={ref} inView={inView}>
      <Container>
        <Header>
          <H1>{activeTab}</H1>
          <TabsWrapper>
            {TABS.map((tab) => (
              <Tab active={activeTab === tab} onClick={() => setActiveTab(tab)}>
                {tab}
              </Tab>
            ))}
          </TabsWrapper>
        </Header>
        {activeTab === "ORDERS" && <OrdersSection />}
        {activeTab === "WISHLIST" && <WishlistSection />}
        {activeTab === "EXCLUSIVES" && <ExclusivesSection />}
      </Container>
    </Wrapper>
  );
}

export default DashboardTabs;
